
import Vue, {
  computed,
  inject,
  onMounted,
} from 'vue';
import IServiceContainer from '@/module/common/service/ServiceContainer/IServiceContainer';
import CFormPageLayout from '@/module/common/components/PageParts/CFormPageLayout.vue';
import VueRouter from 'vue-router';
import EServiceContainerInstances from '@/module/common/service/ServiceContainer/EServiceContainerInstances';
import CFormPageHeaderRow from '@/module/common/components/PageParts/CFormPageHeaderRow.vue';
import DSIcon from '@/module/design-system/components/Icons/DSIcon.vue';
import DSButton from '@/module/design-system/components/UI/DSButton.vue';
import EDSButtonVariant from '@/module/design-system/models/UI/DSButton/EDSButtonVariant';
import EIcon from '@/module/design-system/components/models/EIcon';
import EIconColorName from '@/module/design-system/components/models/EIconColorName';
import CFormPageContent from '@/module/common/components/PageParts/CFormPageContent.vue';
import ProductIconComponent from '@/module/product/components/ProductIconComponent.vue';
import CFormComponent from '@/module/common/components/CFormComponent.vue';
import EventListenerRegister from '@/module/common/service/EventListenerRegister/EventListenerRegister';
import EEventName from '@/module/common/service/NotificationService/model/EEventName';

export default Vue.extend({
  name: 'ProductFormPage',
  components: {
    CFormComponent,
    ProductIconComponent,
    CFormPageContent,
    DSIcon,
    CFormPageHeaderRow,
    CFormPageLayout,
    DSButton,
  },
  setup() {
    const serviceContainer = inject<IServiceContainer>('serviceContainer') as IServiceContainer;
    const router = serviceContainer.resolve<VueRouter>(EServiceContainerInstances.ROUTER);
    const localisationRegistry = serviceContainer.localisationRegistry;
    const dsButtonHelper = serviceContainer.helperService.dsButtonHelper;
    const productFormPage = serviceContainer.moduleProduct.productFormPage;
    const handlerService = serviceContainer.moduleProduct.productFormPage.handlerService;
    const formBlurHandler = handlerService.formBlurHandler;

    const state = serviceContainer.moduleProduct.productFormPage.getState();

    const eventListenerRegister = new EventListenerRegister();
    eventListenerRegister.register(
      EEventName.PRODUCT_TRY_AGAIN,
      () => {
        const formData = productFormPage.handlerService.formDataHandler.get();

        productFormPage.handlerService.saveHandler.save(formData);
      },
    );

    const header = computed(() => ({
      pageTitle: state.isEditMode
        ? localisationRegistry.productsOld.form.editProduct
        : localisationRegistry.productsOld.form.newProduct,
      cancelButton: dsButtonHelper.getButtonWithIcon(
        {
          text: localisationRegistry.productsOld.form.cancel,
          variant: EDSButtonVariant.TRETIARY,
        },
        async () => {
          productFormPage.clearState();

          await router.push('/products/').catch(() => null);
        },
        {
          icon: EIcon.CROSS,
          color: EIconColorName.LINKED,
        },
        true,
      ),
      saveButton: dsButtonHelper.getButton(
        {
          text: localisationRegistry.productsOld.form.save,
          variant: EDSButtonVariant.TRETIARY,
        },
        () => productFormPage.handlerService.saveHandler.save(productFormPage.getState().formData),
        true,
      ),
    }));

    const productIcon = computed(() => ({
      url: state.formData.imageUrl ?? undefined,
      title: state.formData.title ?? undefined,
      error: state.iconLoadError,
      handler: async (event: InputEvent) => {
        const productImageUploadHandler = productFormPage.handlerService.productImageUploadHandler;
        const formDataHandler = productFormPage.handlerService.formDataHandler;

        state.iconLoadError = undefined;

        try {
          const response = await productImageUploadHandler.handle(event);
          const formData = formDataHandler.get();

          formData.imageUrl = response.url;
          formDataHandler.update(formData);
        } catch (error) {
          if (productImageUploadHandler.isValidationError(error)) {
            state.iconLoadError = error.message;
          }
        }
      },
    }));

    onMounted(() => {
      state.isEditMode = !!router.currentRoute.params.id;
      state.formConfig = handlerService.formConfigHandler.get();

      if (!state.isEditMode) {
        state.isLoading = false;
      } else {
        handlerService.loadHandler.load(+router.currentRoute.params.id)
          .then(() => {
            state.isLoading = false;
          });
      }
    });

    return {
      state,
      header,
      productIcon,
      formBlurHandler,
    };
  },
});

